exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-refresh-restore .description-block {\n  padding-bottom: 20px; }\n\n.form-refresh-restore .form-block {\n  margin-top: 0px; }\n\n.form-refresh-restore .form-action {\n  float: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/refresh-restore/refresh-restore.scss
// module id = Vwuu
// module chunks = 0